import { msalInstance } from '../msalConfig';

// Flag que indica que o usuário saiu explicitamente. Enquanto presente, a
// página de login não tenta o SSO silencioso da Microsoft (que relogaria o
// usuário na hora). É limpa quando ele volta a logar por vontade própria.
export const EXPLICIT_LOGOUT_FLAG = 'iris_explicit_logout';

export function performLogout(navigate) {
  localStorage.clear();
  // O cache do MSAL fica em sessionStorage (ver msalConfig.js) — sem limpá-lo,
  // o login silencioso encontra a conta e refaz o login automaticamente.
  sessionStorage.clear();
  msalInstance.setActiveAccount(null);
  sessionStorage.setItem(EXPLICIT_LOGOUT_FLAG, 'true');
  navigate('/');
}
